export type LoopStage = {
  index: string
  title: string
  body: string
}

export const loopStages: LoopStage[] = [
  {
    index: '01',
    title: 'We map the business',
    body: 'What you sell, who buys it, how a lead becomes a job, and where your team loses hours.',
  },
  {
    index: '02',
    title: 'We design and build',
    body: 'Structure, design system, pages, ecommerce, and the integrations it needs to run.',
  },
  {
    index: '03',
    title: 'We launch it properly',
    body: 'Migration, redirects, QA on real devices, then training so your team is not stuck.',
  },
  {
    index: '04',
    title: 'We host and secure it',
    body: 'Managed hosting, SSL, patching, monitoring, and backups with tested restores.',
  },
  {
    index: '05',
    title: 'We handle the updates',
    body: 'Copy, pricing, photos, new pages, new products — send it over and it goes live.',
  },
  {
    index: '06',
    title: 'We track and improve',
    body: 'Calls, forms, quote requests, and orders tell us what to fix and build next.',
  },
]

export const supportChips: string[] = [
  'Phone support',
  'Email support',
  'Ticket support',
  'Remote Hands',
  'SSL certificates',
  'Daily backups',
  'Uptime monitoring',
  'Analytics setup',
  'Staging environment',
  'Team training',
  'Content updates',
  'Security patching',
]
